import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NavComponent } from 'src/app/traits/nav/nav.component';
import { ManagerService } from 'src/app/services/manager.service';

@Component({
  selector: 'app-account-approval',
  templateUrl: './account-approval.component.html',
  styleUrls: ['./account-approval.component.css']
})
export class AccountApprovalComponent implements OnInit {
  accounts: any[] = [];
  constructor(private use: NavComponent, private _api: ManagerService) { }

  ngOnInit() {
    this.getAllAccounts();
  }

  getAllAccounts() {
    this._api.getAccountsByStatus('Pending').subscribe((data: any) => {
      this.accounts = data;
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Account List Fail', 'Unable to Fetch Account List');
    });
  }
  
  confirm(val) {
    val.status = "Active"; val.muserid = this.use.active.id; val.mdate = new Date();
    this._api.putAccount(val.accountid,val).subscribe((data: any) => {
      this.use.showMsg('success', 'Account Approved', 'Account Has been Activated');
    }, (err: HttpErrorResponse) => {
      this.use.showMsg('error', 'Account List Fail', 'Unable to Fetch Account List');
    });
  }

}
